<div class="coverages-outer-container" [formGroup]="form">
  @if (showPremium) {
    <div class="premium-section bolt-justify-content-center">
      <h2 class="premium-monthly" id="condo-premium-monthly">
        {{
        priceSummaryDisplayProduct.installmentPrice
        }}<span class="per-month"><strong>{{
        priceSummaryDisplayProduct.installmentFrequency
      }}</strong></span>
    </h2>
  </div>
  <div class="bolt-row bolt-justify-content-center">
    <h3 class="premium-total" id="condo-premium-total">
      {{ priceSummaryDisplayProduct.totalPrice }}
      {{ priceSummaryDisplayProduct.termLength }}
    </h3>
  </div>
  <hr />
}

<div class="bolt-row effective-container">
  <div class="bolt-col-xs-12 bolt-col-sm-6  unpad-row">
    @if (!showDatePicker) {
      <div
        class="update-effectiveDate-container"
        (click)="showDatePicker = true"
        >
        <a id="ccdc-Effective-date-{{ product.type }}"
          >Effective date {{ form.value.effectiveDate }} </a
          >
          <bolt-icon
            name="pencil"
            [attr.id]="'ccdc-pencil-' + product.type"
            color="mediumBlue"
            [attr.size]="maxSizeMini ? 'sm' : 'md'"
            class="icon-top-padding mt-05"
          ></bolt-icon>
        </div>
      }
      @if (showDatePicker) {
        <nwx-datepicker-input
          controlId="effectiveDate"
          id="ccdc-effective-date"
          name="ccdc-effective-date"
          label="Effective date"
          controlName="effectiveDate"
          placeholder="MM/DD/YYYY"
          [minDate]="policyDateOptions?.minDate || null"
          [maxDate]="policyDateOptions?.maxDate || null"
          [disabled]="(updateInProgress$ | async) || false"
          [relevantProduct]="product.type"
          [quoteCreateDate]="product.quoteCreateDate"
          [bumpHeaderMargin]="true"
        ></nwx-datepicker-input>
      }
    </div>
    <div class="bolt-col-xs-12 bolt-col-sm-6 unpad-row">
      <div
        class="remove-policy-container"
        (click)="promptToRemovePolicy($event)"
        id="ccdc-remove-policy"
        >
        <a href="#">Save submission for later</a>
        <bolt-icon
          name="folder"
          [attr.id]="'ccdc-folder'"
          color="mediumBlue"
          [attr.size]="maxSizeMini ? 'sm' : 'md'"
          class="icon-top-padding"
        ></bolt-icon>
      </div>
      <div
        class="remove-policy-container"
        (click)="promptToWithdrawPolicy($event)"
        >
        <a href="#">Delete submission</a>
        <bolt-icon
          name="trash"
          [attr.id]="'ccdc-trash'"
          color="mediumBlue"
          [attr.size]="maxSizeMini ? 'sm' : 'md'"
          class="icon-top-padding"
        ></bolt-icon>
      </div>
    </div>
  </div>
  <hr />

  @if (showPremium) {
    <div class="details-container">
      <div class="bolt-row bolt-justify-content-between">
        <div class="botl-col-xs-12">
          <nwx-msb-report-number
            [coveredLocation]="coveredLocation"
            [productModel]="product"
            [isLaunchedFromHubPage]="true"
          ></nwx-msb-report-number>
        </div>
      </div>
    </div>
    <hr />
    <div class="details-container">
      <div class="info-row heading">
        <div class="bolt-row bolt-justify-content-between">
          <div class="bolt-col-xs-6">
            <strong>Property Details</strong>
          </div>
        </div>
      </div>
      <div class="bolt-row info-row">
        <div class="bolt-col-xs nwpii">{{ formattedAddress }}</div>
      </div>
      <div class="bolt-row bolt-justify-content-between info-row">
        <div class="bolt-col-xs-6">Year built</div>
        <div class="bolt-col-xs-6">
          {{ coveredLocation?.constructionInfo?.yearBuilt }}
        </div>
      </div>
    </div>
    <hr class="coverages-divider" />
    <details class="details-container">
      <summary><strong>Coverages</strong></summary>
      @for (coverage of displayCoverages; track coverage.name) {
        <div
          class="bolt-row bolt-justify-content-between"
          >
          <div class="bolt-col-xs-6 info-row indent">{{ coverage.name }}</div>
          <div class="bolt-col-xs-6 info-row">
            {{ coverage.value }}
          </div>
        </div>
      }
    </details>
    <hr class="coverages-divider" />
    <details class="details-container">
      <summary><strong>Deductibles</strong></summary>
      @for (deductible of displayDeductibles; track deductible.name) {
        <div
          class="bolt-row bolt-justify-content-between"
          >
          <div class="bolt-col-xs-6 info-row indent">{{ deductible.name }}</div>
          <div class="bolt-col-xs-6 info-row">
            {{ deductible.value }}
          </div>
        </div>
      }
    </details>
  } @else {
    <div class="coverages-footer pb-20" id="ccdc-premiumSubstitute">
      <nwx-notification-bubble type="info">
        <p style="font-size: large; font-weight: 500;">Review your rating tasks</p>
        <p>The rate isn’t available, because there may be unfinished tasks or errors. If you see any errors, request UW approval.</p>
        <div class="d-flex flex-column bolt-justify-content-between">
          <bolt-button color="mediumBlue"
            type="outline"
            class="button-float"
            size="md"
            (click)="scrollToTasks()"
            >Review rating tasks</bolt-button
            >
          </div>
        </nwx-notification-bubble>
      </div>
      <hr />
      <div class="details-container-last"></div>
    }
    <div class="button-container">
      <div class="bolt-row">
        <div class="bolt-col-xs">
          <bolt-button
            type="solid"
            size="sm"
            [attr.id]="'acdc-view-edit-coverage'"
            (click)="editCoverages()"
            >View/edit all coverages</bolt-button
            >
          </div>
        </div>
      </div>
    </div>

